import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    isLayoutMobile: boolean;
  }>()
  .create(({ theme, isLayoutMobile }) => ({
    dualListSelectButton: {
      minWidth: '8.75rem'
    },
    dualListSelectIcon: {
      fontSize: '0.75rem!important'
    },
    dualListSelectList: {
      border: `1px solid ${theme.vars.palette.divider}`,
      flex: 1,
      overflow: 'auto',
      maxHeight: isLayoutMobile ? 100 : 'inherit'
    },
    dualListSelectPaper: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      padding: '1rem',
      width: isLayoutMobile ? '28rem' : '16rem'
    },
    dualListSelectPaperTypography: {
      padding: '1rem 0',
      textAlign: 'center',
      width: '100%'
    }
  }));

export default useStyles;
